import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LiveCloudApi {

  private readonly saasEnabled: string = 'topology/lc/saas';


  constructor(private http: HttpClient) {}

  public getSaasEnabled(): Promise<any> {
    return this.http.get(this.saasEnabled).toPromise();
  }
}
